import React from 'react'

export default ({ station, onStationClick }) => {
  const handleClick = () => {
    if (station && onStationClick) onStationClick(station)
  }

  return (
    <button
      onClick={handleClick}
      className="group relative bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden flex focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 w-full text-left
        flex-row md:flex-col hover:scale-[1.02] md:hover:scale-105"
    >
      {/* Image Container - 1:1 on mobile (left), 4:3 on md+ (top) */}
      <div className="flex-shrink-0 w-20 h-20 md:w-full md:h-auto md:aspect-[4/3] overflow-hidden bg-gray-100">
        <img
          src={station.image || '/assets/images/no_image.png'}
          alt={station.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
        />
      </div>

      {/* Info Container */}
      <div className="flex-1 p-3 md:p-4 flex flex-col justify-center">
        <h3 className="text-sm md:text-base font-semibold text-gray-900 leading-tight mb-1">
          {station.name}
        </h3>
        <p className="text-xs md:text-sm text-primary-600 font-medium">
          {station.serviceClass}
        </p>
      </div>
    </button>
  )
}
